/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { RiHospitalFill, RiInformationFill } from "react-icons/ri";
import { ImHome2 } from "react-icons/im";
import { MdContactSupport, MdDashboard, MdHealthAndSafety, MdPerson2, MdPrivacyTip, MdSettings, MdUpdate } from "react-icons/md";
import { useAuth } from '../../context/UserContext';
import { FiLogOut } from 'react-icons/fi';
import { FaUserNurse } from "react-icons/fa6";
import toast from 'react-hot-toast';
import { FaMoneyBillTransfer } from "react-icons/fa6";
import { FaLifeRing } from 'react-icons/fa';

function Drawer() {
    const { isAuth, logout } = useAuth()
    const location = useLocation()
    const navigate = useNavigate()

    const getLinkClass = (path) => {
        if (!path) {
            return "flex items-center w-full p-3 rounded-xl transition-all duration-200 text-base-content/70 hover:bg-base-200 hover:text-base-content";
        }

        const isActive = location.pathname === path;
        const baseClasses = "flex items-center w-full p-3 rounded-xl transition-all duration-200";

        if (isActive) {
            return `${baseClasses} bg-primary text-white shadow-lg shadow-primary/30 font-semibold 
                hover:bg-primary/90 hover:shadow-xl hover:shadow-primary/40 hover:scale-[1.02]`;
        } else {
            return `${baseClasses} text-base-content/70 hover:bg-base-200 hover:text-base-content 
                hover:shadow-md transition-all duration-200`;
        }
    };

    function handleUlClick(event) {
        if (event.target.closest('a') || event.target.closest('button')) {
            closeDrawer()
        }
    }

    function closeDrawer() {
        const drawerToggle = document.getElementById("nav-drawer")
        if (drawerToggle) drawerToggle.click()
    }

    function handleLogout() {
        logout();
        closeDrawer();
        navigate('/auth/login');
        setTimeout(() => {
            toast.success('Successfully logged out');
        }, 400);
    };

    return (
        <div className="drawer-side border-r z-50">
            <label htmlFor="nav-drawer" className="drawer-overlay"></label>

            <div className="flex flex-col p-4 w-64 bg-base-100 h-full overflow-y-auto lg:h-auto lg:overflow-visible">

                <div className="pb-4 flex-shrink-0">
                    <div className="flex justify-center">
                        <Link to={'/'} className='p-3 rounded-xl bg-primary/10 hover:bg-primary/20 transition-colors'>
                            <h1 className='text-xl font-bold uppercase tracking-wide'>Health<span className='text-primary'>Connect</span></h1>
                        </Link>
                    </div>
                </div>

                <ul
                    onClick={handleUlClick}
                    className="menu flex-grow space-y-1">

                    {isAuth && (
                        <>
                            <li className="menu-title text-xs uppercase text-base-content/50 pl-3">Admin Panel</li>
                            <li>
                                <Link to='/admin/dashboard' className={getLinkClass('/admin/dashboard')}>
                                    <MdDashboard className='h-5 w-5 mr-3' /> Dashboard
                                </Link>
                            </li>
                            <li>
                                <Link to='/dashboard/services' className={getLinkClass('/dashboard/services')}>
                                    <MdHealthAndSafety className='h-5 w-5 mr-3' /> Services
                                </Link>
                            </li>
                            <li>
                                <Link to='/dashboard/nurses' className={getLinkClass('/dashboard/nurses')}>
                                    <FaUserNurse className='h-5 w-5 mr-3' /> Nurses
                                </Link>
                            </li>
                            <li>
                                <Link to='/dashboard/patients' className={getLinkClass('/dashboard/patients')}>
                                    <MdPerson2 className='h-5 w-5 mr-3' /> Patients
                                </Link>
                            </li>
                            <li>
                                <Link to='/dashboard/requests' className={getLinkClass('/dashboard/requests')}>
                                    <MdUpdate className='h-5 w-5 mr-3' /> Requests
                                </Link>
                            </li>
                            <li>
                                <Link to='/dashboard/payments' className={getLinkClass('/dashboard/payments')}>
                                    <FaMoneyBillTransfer className='h-5 w-5 mr-3' /> Payments
                                </Link>
                            </li>
                            <li>
                                <Link to='/auth/settings' className={getLinkClass('/auth/settings')}>
                                    <MdSettings className='h-5 w-5 mr-3' /> Settings
                                </Link>
                            </li>
                            <li>
                                <button onClick={handleLogout} className={getLinkClass(null)}>
                                    <FiLogOut className='h-5 w-5 mr-3' /> Logout
                                </button>
                            </li>
                            <div className="divider my-2"></div>
                        </>
                    )}

                    <li className="menu-title text-xs uppercase text-base-content/50 pl-3">General</li>
                    <li>
                        <Link to='/' className={getLinkClass('/')}>
                            <ImHome2 className='h-5 w-5 mr-3' /> Home
                        </Link>
                    </li>
                    <li>
                        <Link to='/about' className={getLinkClass('/about')}>
                            <RiInformationFill className='h-5 w-5 mr-3' /> About
                        </Link>
                    </li>
                    <li>
                        <Link to='/services' className={getLinkClass('/services')}>
                            <RiHospitalFill className='h-5 w-5 mr-3' /> Services
                        </Link>
                    </li>
                    <li>
                        <Link to='/help' className={getLinkClass('/help')}>
                            <FaLifeRing className='h-5 w-5 mr-3' /> Help
                        </Link>
                    </li>
                    <li>
                        <Link to='/contact' className={getLinkClass('/contact')}>
                            <MdContactSupport className='h-5 w-5 mr-3' /> Contact Us
                        </Link>
                    </li>
                    <li>
                        <Link to='/privacy' className={getLinkClass('/privacy')}>
                            <MdPrivacyTip className='h-5 w-5 mr-3' /> Privacy Policy
                        </Link>
                    </li>
                </ul>

                <div className={`mt-auto flex-shrink-0 ${!isAuth ? 'pt-4 lg:pt-44' : 'lg:pt-10'}`}>
                    {!isAuth ? (
                        <Link to='/#patient-process' className="btn btn-primary rounded-xl w-full shadow-md shadow-primary/20 hover:shadow-lg hover:shadow-primary/30 transition-all">
                            Get Started
                        </Link>
                    ) : (
                        <div className="text-center text-xs text-base-content/50">
                            Logged in as Admin
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Drawer